// TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
export const colors = {
  darkNavy: '#071022',
  darkNavyTypography: '#061231',
  lightNavy: '#F3F5F8',
  warmGray: '#F4F4EF',
  brand: {
    darkestBlue: '#161d2d',
  },
};

// Todo: https://linear.app/republic/issue/USMKT-1556/adjust-container-component-width
export const containerSize = '1432px';

// Transform Inter (var) to InterDisplay
// TODO: https://linear.app/republic/issue/CLG-75/dls-update-fonts-for-headings - revisit approach
export const InterDisplayStyles = {
  fontVariationSettings: "'opsz' 32",
  fontFeatureSettings: '"ss01", "cv06", "cv11", "cv12", "cv13"',
};
